import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { Oval } from "react-loader-spinner";

const Login = () => {
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [Loader, setLoader] = useState(false);
  const [, setApi] = useState([]);

  const Navigate = useNavigate();

  const login = () => {
    setLoader(true);
    try {
      const data = new FormData();
      data.append("email", Email);
      data.append("password", Password);

      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/login`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.data);
          if (response.data.data.status === true) {
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("email", response.data.data.user.email);
            localStorage.setItem("id", response.data.data.id);
            setLoader(false);
            Swal.fire({
              title: "Good job! ",
              text: "Login Successfully",
              icon: "success",
              button: "Ok",
            });
            Navigate("/");
          } else {
            setLoader(false);
            Swal.fire({
              title: "Opps! ",
              text: response.data.error,
              icon: "error",
              button: "Ok",
            });
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  return (
    <>
      <main>
        <div class="bg_color_2">
          <div class="container margin_60_35">
              <div className="row pb-3">
              <div className="col-lg-8">
              <span className="d-flex">
              <img src="./fav.png" className="rejisterimg" alt="ok" />
              <span className="rejisterspan text-white">DENTECTIVE</span>
              </span>
              </div>
              <div class="box_form col-lg-4">
                <form>
                  <h2 className="text-center pb-4 text-theme">Login</h2>
                  <hr className="text-white"/>
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Your email address"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Your password"
                      id="password"
                      name="password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <p class="text-start link_bright text-white">
                Do not have an account yet?{" "}
                <Link to="/register">
                  <strong className="text-theme">Register now!</strong>
                </Link>
              </p>
                  <Link to="/forgot">
                    <small className="text-theme">Forgot password?</small>
                  </Link>
              
                </form>
                <div class="form-group text-center add_top_20">
                  <button
                    class="btn-theme w-50 mx-auto d-flex justify-content-center align-items-center"
                    onClick={login}
                  >
                    {Loader === true ? (
                      <Oval
                        height={30}
                        width={30}
                        color="#fff"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </div>
            </div>
            {/* <!-- /login --> */}
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
